/* Seif Edition — one-tap add from the cart drawer upsell. Loaded on every page. */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-seif-cart-add]');
  if (!button || button.disabled) return;
  const cart = document.querySelector('cart-drawer');
  if (!cart) return;
  const label = button.textContent;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  try {
    const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.seifCartAdd), quantity: 1 }],
        sections: cart.getSectionsToRender().map((s) => s.id),
        sections_url: location.pathname,
      }),
    });
    const state = await response.json();
    if (!response.ok || state.status) throw new Error(state.description);
    cart.renderContents(state);
  } catch (error) {
    button.textContent = 'Sold out';
    setTimeout(() => {
      button.textContent = label;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }, 1600);
  }
});
